module.exports = __webpack_public_path__ + "media/images/landkit/patterns/pattern-2-df851282cc0899ae1baa174eafb96763.png";